var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Databus } from '@portals/databus';
export var mapperValues = function (currentPropValues, name) {
    return Object.entries(currentPropValues).reduce(function (accumValues, _a) {
        var _b;
        var fieldName = _a[0], selectFunc = _a[1];
        var selectedData = Databus.dataState[name];
        return __assign(__assign({}, accumValues), (_b = {}, _b[fieldName] = selectFunc(selectedData), _b));
    }, {});
};
